import Vue from 'vue'

export default {
	list({}, filter) {
		return Vue.api.post('agenda/list', {
			"per_page": filter.per_page || 200,
			"current_page": filter.current_page || 1,
			"access": true,
			"clinic_id": filter.clinic_id,
			"user_ids": filter.user_ids,
			"worker_ids": filter.worker_ids,
			"status": filter.status,
			"status_array": filter.status_array,
			"sort": filter.sort || "asc",
			"begin": filter.begin,
			"end": filter.end,
			"type": filter.type || ["work"],
			"description": filter.description,
            "price": filter.price,
            "deposit": filter.deposit,
		})
	},
	byDate({}, data) {
		data.type = ['work'];
		return Vue.api.post('agenda/date/list', data)
	},
	create({}, data) {
		return Vue.api.post('agenda/', {
			"begin": data.begin,
			"end": data.end,
			"expire_time": data.expire_time || null,
			"access": data.access || true,
			"clinic_id": data.clinic_id || null,
			"user_ids": data.user_ids || [],
			"worker_ids": data.worker_ids || [],
			"status": data.status || "not_confirmed",
			"type": data.work || ["work"],
			"description": data.description || '',
			"price": data.price || '',
			"deposit": data.deposit || '',
		})
	},
	get({}, id) {
		return Vue.api.get('agenda/' + id)
	},
	update({}, data) {
		return Vue.api.put('agenda/' + data.id, {
			"begin": data.begin,
			"end": data.end,
			"expire_time": data.expire_time,
			"access": data.access,
			"clinic_id": data.clinic_id,
			"user_ids": data.user_ids,
			"worker_ids": data.worker_ids,
			"status": data.status || "not_confirmed",
			"type": data.work || ["work"],
			"description": data.description,
			"price": data.price,
			"deposit": data.deposit,
		})
	},
	sendAnswer(store, notification) {
		let action = notification.model.type.match(/[a-z_]+/g)[2];
		let field = notification.model.type.match(/[a-z_]+/g)[3];

		return store.dispatch(action, {
			id: notification.model.data.agenda.new._id,
			[field]: (notification.responseType === 'approve') ? 'confirmed' : 'canceled'
		})
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/agenda/actions.js